export default {
  computed: {
    roofBridgeUpper() {
      let product = this.products.find(p => p.type === 'roofBridgeUpper')
      let variant = product.variants.find(v => v.color == this.selections.accessoryColor.value)
      let fullProduct = { ...product, ...variant }
      delete fullProduct.variants;

      const amount = this.roofBridgeConsole.amount;

      // Add properties
      fullProduct.singlepack = amount;
      fullProduct.amount = amount;
      fullProduct.unit = 'st';
      fullProduct.sort = 10

      return fullProduct;
    }
  }
};
